module.exports = "/_next/static/images/940d276bf1f02f69e1b7454b4806e8c0-pj-phone-and-business-card@3x.jpg";